export const toCnpjMask = (document: string | undefined) => {
  if (!document) return '';
  const cnpj = document.replace(/[^\d]/g, '');
  return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};
